import { Badge, List, Tag } from 'antd';
import React from 'react';
import clx from 'classnames';
import { TipoErroriAnomalia } from 'server/schema/integrations/pdnd/schema/schemas';
import './PDNDResponseWarningList.scss';
import { VerticalSpace } from 'client/ui/space/VerticalSpace';

interface IPDNDResponseWarningListProps {
  warnings?: TipoErroriAnomalia[] | undefined;
}

export function PDNDResponseWarningList(props: IPDNDResponseWarningListProps) {
  const { warnings } = props;

  if (!warnings || warnings.length === 0) return null;

  return (
    <div className="PDNDResponseWarningList">
      <List
        size="small"
        header={
          <div>
            Lista Anomalie <Badge size="small" count={warnings.length} />
          </div>
        }
        bordered
        dataSource={warnings}
        renderItem={item => (
          <List.Item
            className={clx('message-item', {
              warning: item.tipoErroreAnomalia?.toLowerCase() == 'w',
              error: item.tipoErroreAnomalia?.toLowerCase() == 'e'
            })}
          >
            <List.Item.Meta
              avatar={
                <Tag
                  className={clx('message-meta-tag', {})}
                  // color="red"
                  children={item.codiceErroreAnomalia}
                />
              }
              title={item.testoErroreAnomalia}
              description={item.oggettoErroreAnomalia}
            />
          </List.Item>
        )}
      />
      <VerticalSpace />
    </div>
  );
}
